import * as constants from '../constants';
import { Messages, MessageCategory } from '../models/index';
import * as add from './addMessage';
import * as deleteMessage from './deleteMessage';
import * as searchMessage from './searchMessage';
import * as editMessage from './editMessage';
import * as auth from './auth';
import * as copyMessage from './copyMessage';
import * as cancelEditMessage from './cancelEditMessage';
import * as sortMessages from './sortMessages';
import * as categories from './categories';
import * as session from './session';


export * from './addMessage';
export * from './deleteMessage';
export * from './searchMessage';
export * from './auth';
export * from './editMessage';
export * from './auth';
export * from './copyMessage';
export * from './cancelEditMessage';
export * from './sortMessages';
export * from './categories';
export * from './session';


export interface ViewMessagesRequest {
  type: constants.VIEW_MESSAGES_REQUEST;
}

export interface ViewMessagesSuccess {
  type: constants.VIEW_MESSAGES_SUCCESS;
  messages: Messages;
}

export interface ViewMessagesFailure {
  type: constants.VIEW_MESSAGES_FAILURE;
  error: string;
}

export interface MessagesPrevPage {
  type: constants.MESSAGES_PREV_PAGE;
}

export interface MessagesNextPage {
  type: constants.MESSAGES_NEXT_PAGE;
}

export interface ResetMessageState {
  type: constants.RESET_MESSAGE_STATE;
}

export interface DismissMessageBanner {
  type: constants.DISMISS_MESSAGE_BANNER;
}

export interface MessageCategoryData {
  messageCategories: MessageCategory[];
  type: constants.MESSAGES_CATEGORY_DATA;
}

export const viewMessagesRequest = (): ViewMessagesRequest => {
  return {
    type: constants.VIEW_MESSAGES_REQUEST,
  };
};

export const viewMessagesSuccess = (messages: Messages): ViewMessagesSuccess => {
  return {
    messages,
    type: constants.VIEW_MESSAGES_SUCCESS,
  };
};

export const viewMessagesFailure = (error: string): ViewMessagesFailure => {
  return {
    error,
    type: constants.VIEW_MESSAGES_FAILURE,
  };
};

export const messagesPrevPage = (): MessagesPrevPage => {
  return {
    type: constants.MESSAGES_PREV_PAGE,
  };
};

export const messagesNextPage = (): MessagesNextPage => {
  return {
    type: constants.MESSAGES_NEXT_PAGE,
  };
};


export const resetMessageState = (): ResetMessageState => {
  return {
    type: constants.RESET_MESSAGE_STATE,
  };
};

export const dismissMessageBanner = (): DismissMessageBanner => {
  return {
    type: constants.DISMISS_MESSAGE_BANNER,
  };
};

export const messageCategoryData = (messageCategories: MessageCategory[]): MessageCategoryData => ({
  messageCategories,
  type: constants.MESSAGES_CATEGORY_DATA,
});


export type MessageAction = add.AddMessageRequest
| add.AddMessageSuccess
| add.AddMessageFailure 
| ViewMessagesRequest
| ViewMessagesSuccess
| ViewMessagesFailure
| MessagesPrevPage
| MessagesNextPage
| deleteMessage.DeleteMessageRequest
| deleteMessage.DeleteMessageSuccess
| deleteMessage.DeleteMessageFailure
| searchMessage.SearchMessageRequest
| searchMessage.SearchMessageSuccess
| editMessage.EditMessageRequest
| editMessage.EditMessageSuccess
| editMessage.EditMessageFailure
| ResetMessageState
| copyMessage.CopyMessageRequest
| copyMessage.CopyMessageSuccess
| copyMessage.CopyMessageFailure
| cancelEditMessage.CancelEditMessage
| DismissMessageBanner
| add.ShowAddMessageSection
| add.HideAddMessageSection
| editMessage.ShowEditMessagesView
| editMessage.HideEditMessagesView
| sortMessages.SortMessageRequest
| sortMessages.SortMessageSuccess
| sortMessages.SortMessageFailure
| sortMessages.SortMessageInMemory
| sortMessages.SortMessageCancelPrevRequest
| sortMessages.CategorySortMessageCancelPrevRequest
| sortMessages.CategorySortMessageFailure
| sortMessages.CategorySortMessageInMemory
| sortMessages.CategorySortMessageRequest
| sortMessages.CategorySortMessageSuccess
| MessageCategoryData
| categories.CategoryActions
| session.SessionAction;

export type AppAction = MessageAction | auth.AuthAction;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/index.ts